import * as React from 'react'
import { useEffect, useState } from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import { CPVariable } from '../models/CPVariable';
import RichTextEditorComponent from './RichTextEditorComponent';

export interface PartTextComponentProps {
    partText: string,
    changePartText: Function,
    variables: Array<CPVariable>,
    userIsOwner: boolean,
    limitedEditing: boolean,
    selectedPartIndex: number,
}

const PartTextComponent = (props: PartTextComponentProps) => {

    const partTextToBlocks = htmlToDraft(props.partText)
    const [editorState, setEditorState] = useState(
        () => EditorState.createWithContent(ContentState.createFromBlockArray(partTextToBlocks.contentBlocks, partTextToBlocks.entityMap)),
    )

    useEffect(() => {
        var blocks = htmlToDraft(props.partText)
        setEditorState(() => EditorState.createWithContent(ContentState.createFromBlockArray(blocks.contentBlocks, blocks.entityMap)),)
    }, [props.selectedPartIndex])

    const changeEditor = editorState => {
        const rawContentState = convertToRaw(editorState.getCurrentContent())
        const markup = draftToHtml(
            rawContentState,
        )
        if (markup.length <= 5000) {
            props.changePartText(markup)
            setEditorState(editorState)
        }
    }

    return (
        <div className="row my-2">
            <div className="col">
                <b>Part Text:</b>
                <RichTextEditorComponent
                    editorState={editorState}
                    changeEditor={changeEditor}
                    placeholder="Part Text"
                    maxCharacters={500}
                    showSymbolDropdown={true}
                    readOnly={!props.userIsOwner}
                    variables={props.variables}
                />
            </div>

        </div>
    )
}



export default PartTextComponent;